<template>
    <div class="user-portfolio-project">
        <div class="user-portfolio-project__image">
            <img v-if="item.image_link" :src="item.image_link" alt="" />
            <img v-else src="~@/assets/images/portfolio/no-image.svg" alt="" />
        </div>
        <div class="user-portfolio-project__content">
            <div class="user-portfolio-project__content-name">
                {{ item.name }}
            </div>

            <div class="project-nominations">
                <div
                    v-if="nomination"
                    class="project-nominations-item"
                >
                    <div class="project-nominations-item__status">
                        <div class="project-nominations-item__status-name">
                            Статус:
                            <strong :class="{
                                [`project-nominations-item__status-name--${nominationStatusClass(nomination.userStatusId)}`]: true,
                            }">{{ nominationStatusName(nomination.userStatusId) }}</strong>
                        </div>
                        <div class="project-nominations-item__status-dates">
                            {{ nominationDateString(item.dateStart, item.dateEnd) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import moment from "moment";

export default {
    props: {
        item: Object,
    },
    computed: {
        ...mapGetters('data', [
            'getRegistryItems',
        ]),

        rsvDomain() {
            return window.rsvDomain;
        },

        nomination() {
            const nomination = this.item.nominations && this.item.nominations.length
                ? this.item.nominations[0]
                : null
            ;
            return nomination || null;
        },
    },
    methods: {
        nominationStatusName(id) {
            const nomination = this.getRegistryItems('stage_history').find(v => v.id === id);
            return nomination ? nomination.field_value : 'нет данных';
        },

        nominationDateString(dateStart, dateEnd) {
            return [
                dateStart ? moment(dateStart).format('DD.MM.YYYY') : null,
                dateEnd ? moment(dateEnd).format('DD.MM.YYYY') : null,
            ].filter(v => v).join(' – ');
        },

        nominationStatusClass(id) {
            const nomination = this.getRegistryItems('stage_history').find(v => v.id === id);
            return nomination ? nomination.field_name : 'default';
        },
    },
};

</script>

<style scoped lang="scss">
@import "~@/styles/rem";
@import '~@/styles/variables';

.user-portfolio-project {
    display: flex;
    flex-direction: column;
    gap: mrem(16);

    @include on-desktop {
        display: grid;
        grid-template-columns: rem(180) auto;
        gap: rem(16);
    }

    &:hover {
        text-decoration: none;
    }

    &__image {
        flex: 0 1 auto;
        width: 100%;

        img {
            width: 100%;
            border-radius: rem(16);
        }
    }

    &__content {
        &-name {
            font-weight: 700;
            margin-bottom: mrem(16);

            @include on-desktop {
                margin-bottom: rem(16);
            }
        }
    }

    .project-nominations {
        background: #fff;
        border-radius: mrem(16);
        padding: mrem(16);

        @include on-desktop {
            border-radius: rem(16);
            padding: rem(16);
        }

        .project-nominations-item {
            display: flex;
            flex-direction: column;
            padding: mrem(6) 0;
            gap: mrem(6);

            @include on-desktop {
                padding: rem(6) 0;
                gap: rem(6);
            }

            & + .project-nominations-item {
                border-top: mrem(1) solid $color-main-primary-light;

                @include on-desktop {
                    border-top-width: rem(1);
                }
            }

            &__status {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                gap: mrem(6);

                @include on-desktop {
                    flex-direction: row;
                    gap: rem(6);
                }

                &-name {
                    font-weight: 600;

                    $statusClasses: (
                        "default": $color-main-red, // по-умолчанию
                        "expert": $color-main-blue, // "Эксперт"
                        "candidate": $color-main-blue, // "Кандидат"
                        "final": $color-secondary-violet, // "Финалист"
                        "hero": $color-main-blue, // "Герой"
                        "star": $color-main-blue, // "Звезда"
                        "party": $color-main-green, // "Участник"
                        "volont": $color-main-blue, // "Волонтер"
                        "knewer": $color-main-blue, // "Знаток"
                        "profi": $color-main-blue, // "Профи"
                        "new": $color-main-blue, // "Новичок"
                        "super": $color-main-blue, // "Суперфиналист"
                        "sledopyt": $color-main-blue, // "Следопыт"
                        "winner": $color-main-blue, // "Победитель"
                        "mentor": $color-main-blue, // "Наставник"
                        "student": $color-main-blue, // "Студент"
                        "graduate": $color-main-blue, // "Выпускник"
                        "prise": $color-main-blue, // "Призер"
                        "teacher": $color-main-blue, // "Лектор"
                        "half": $color-main-light_blue, // "Полуфиналист"
                        "main": $color-main-blue, // "Капитан"
                    );
                    @each $name, $color in $statusClasses {
                        &--#{$name} {
                            color: $color;
                        }
                    }

                    strong {

                    }
                }
                &-dates {
                    flex: 0 0 auto;
                    color: $color-secondary-grey;
                    font-weight: 500;
                    font-size: mrem(14);
                    line-height: mrem(22);

                    @include on-desktop {
                        font-size: rem(14);
                        line-height: rem(22);
                    }
                }
            }
        }
    }
}

</style>
